import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable } from 'rxjs';
import { SiteFamilyConfig } from '../../model';
import { Occ } from '../../occ/occ-models';

@Injectable({
  providedIn: 'root',
})
export class SiteFamilyConfigConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  load(userId: string): Observable<SiteFamilyConfig> {
    let headers = new HttpHeaders();

    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    const url = this.occEndpointsService.buildUrl('siteFamilyConfig');
    return this.httpClient.get<Occ.SiteFamilyConfig>(url, { headers });
  }
}
